<template>
  <div class="row mt-3">
    <div class="col-md-12">
      <div class="section-header">
        <h3>Mes souscriptions</h3>
        <p class="text-muted font-weight-light">
          Produits & services souscrits et en cours de validité sur mon compte
        </p>
      </div>
    </div>

    <SubscriptionCard
      v-for="bundle in $store.state.core.subscriptions"
      :key="bundle.id"
      :bundle="bundle"
    />

    <div
      v-if="
        isArray($store.state.core.subscriptions) &&
        isEmpty($store.state.core.subscriptions)
      "
      class="col-md-12"
    >
      <div id="no_subscription_box" class="text-muted">
        Vous n'avez souscrit à aucun service pour le moment.
      </div>
    </div>

    <div
      v-if="$store.state.core.subscriptions == null"
      class="col-md-6"
      v-for="(i, index) in 2"
      :key="index"
    >
      <b-skeleton height="120px"></b-skeleton>
    </div>
  </div>
</template>

<script>
import { subscriber } from "@/services/";
import SubscriptionCard from "@/components/utils/SubscriptionCard";
export default {
  components: { SubscriptionCard },
  name: "SubscriptionBox",
  data: function () {
    return {};
  },
  created: async function () {
    await subscriber.get_subscriptions();
  },
  methods: {
    get_bill_field: function (field, sub_field) {
      try {
        return this.$store.state.core.subscriptions.total[field][sub_field];
      } catch (error) {
        return null;
      }
    },
  },
};
</script>
<style scoped lang="css">
</style>
